import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestApiService } from '../shared/rest-api.service';
//import { Organisation } from './organisation';
//import { OrganisationUnit } from './organisation-unit';
//import { Globals } from '../shared/globals';
import { environment } from '../../environments/environment';
//import { Node } from '../unit/node';
//import { Router, ActivatedRoute, Params, ParamMap } from '@angular/router';

@Injectable()
export class OrganisationService {

  endpoint: string = 'organisation';
  period!: string;
  //curriculumPeriod = environment.curriculumPeriod; //pituus
  queryParam!: string; //= '?period=2022-2024';

  constructor(
    //public globals: Globals,
    private api: RestApiService
    ){ 
      //this.globals.schoolYearChanged.subscribe(year => this.onPeriodChange(year)); 
    }


  /*getOrganisationTree(): Observable<Organisation[]> {
    return this.api.getList<Organisation>('organisation/tree');
  }*/


  /*getOrganisation(id: string): Observable<Organisation> {
    return this.api.getOne<Organisation>(this.endpoint, id);
  }*/


  getOrganisations(): Observable<any[]> {
    return this.api.getList(this.endpoint);
  }

  getOrganisation(id: string): Observable<any[]> {
    return this.api.getOne(this.endpoint, id);
  }

  getSubOrganisations(id: string): Observable<any[]> {
    return this.api.getSubList(this.endpoint + '/units', id);
  }

  /*
  getEducationList<T>(organisation: string, educationType: string): Observable<T[]> {
    return this.api.getList(`/education/${organisation}/${educationType}`)
  }

  getEducationListByType<T>(id: string): Observable<T[]> {
    return this.api.getList(`/education/${id}/education-type`);
  }

  getEducations(organisation: string, educationType: string): Observable<any> {
    return this.api.getEducationList(organisation, educationType);
  }

  getEducationListBySchoolYear<T>(id: string): Observable<T[]> {
    return this.api.getList(`education/${id}`);
  }
  getEducationsByType(id: string): Observable<Node[]> {
    return this.api.getEducationListByType(id);
  }
  getEducationDescriptions(id: string): Observable<Object[]> {
    return this.api.getList<Object>('education/description/' + id);
  }

  getEducationTypesByOrganisation(id: string): Observable<any> {
    return this.api.getList('education-type/' + id);
  }*/

  /*private onPeriodChange(year: number): void {
    this.queryParam = '?period=' + this.globals.selectedSchoolYear.toString() + '-' + (this.globals.selectedSchoolYear+this.curriculumPeriod).toString();
    //console.log(this.period);
   }*/

}
